'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _modal = require('redux/actions/modal');

var _pass_recovery = require('redux/actions/pass_recovery');

var _voice_code = require('redux/actions/voice_code');

var _BaseForm2 = require('../../BaseForm');

var _BaseForm3 = _interopRequireDefault(_BaseForm2);

var _helpers = require('helpers');

var _Validators = require('../Validators');

var Validators = _interopRequireWildcard(_Validators);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PassRecoveryStepTwo = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        preload: state.passRecovery.preload,
        error: state.passRecovery.error,
        errorCode: state.passRecovery.errorCode,
        lang: state.lang
    };
}, { hide: _modal.hide, confirmPassRecovery: _pass_recovery.confirmPassRecovery, resetVoiceCode: _voice_code.resetVoiceCode, showError: _pass_recovery.showError }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
    (0, _inherits3.default)(PassRecoveryStepTwo, _BaseForm);

    function PassRecoveryStepTwo(props, context) {
        (0, _classCallCheck3.default)(this, PassRecoveryStepTwo);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PassRecoveryStepTwo.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepTwo)).call(this, props, context));

        _this.changeFieldCode = function (event) {
            event.preventDefault();
            _this.props.changeFieldCode(event.target.value);
        };

        _this.changeFieldPassword = function (event) {
            event.preventDefault();
            _this.props.changeFieldPassword(event.target.value);
        };

        _this.isMinValid = function () {
            return _this.props.password.length > 0 && _this.props.code.length > 0;
        };

        _this.showOuterAlert = function (alert) {
            _this.setState({ outerAlert: alert });
        };

        _this.state = {
            alert: null,
            outerAlert: null,
            error: null,
            errorCode: null
        };
        return _this;
    }

    (0, _createClass3.default)(PassRecoveryStepTwo, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetVoiceCode();
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(event) {
            event.preventDefault();
            (0, _get3.default)(PassRecoveryStepTwo.prototype.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepTwo.prototype), 'onSubmit', this).call(this, event);

            if (this.isValid()) {
                //this.setState({error: '', errorCode: null});
                this.props.resetVoiceCode();
                this.props.confirmPassRecovery(this.props.login, this.props.password, this.props.code);
            }
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            var errorMessage = this.props.lang['store.password_recovery.pass_length_error'];
            if (!Validators.minLength(this.props.password, 6)) {
                //this.setState({error: errorMessage, errorCode: 400});
                this.props.showError({ message: errorMessage, code: 400 });
                return false;
            }

            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('PassRecoveryStepTwo', null, { folderName: "PassRecovery/PassRecoveryStepTwo" });

            return _react2.default.createElement(View, {
                changeFieldCode: this.changeFieldCode,
                changeFieldPassword: this.changeFieldPassword,
                disabledSubmit: !this.isMinValid(),
                onSubmit: this.onSubmit,
                code: this.props.code,
                password: this.props.password,
                preload: this.props.preload,
                alert: this.state.alert,
                error: this.state.error || this.props.error || '',
                login: this.props.login,
                showOuterAlert: this.showOuterAlert,
                outerAlert: this.state.outerAlert,
                errorCode: this.state.errorCode || this.props.errorCode,
                isEmail: /@/.test(this.props.login),
                lang: this.props.lang
            });
        }
    }]);
    return PassRecoveryStepTwo;
}(_BaseForm3.default), _class2.propTypes = {
    password: _react.PropTypes.string.isRequired,
    code: _react.PropTypes.string.isRequired,
    login: _react.PropTypes.string.isRequired,
    changeFieldCode: _react.PropTypes.func,
    changeFieldPassword: _react.PropTypes.func,
    lang: _react.PropTypes.object
}, _class2.defaultProps = {
    changeFieldCode: function changeFieldCode() {},
    changeFieldPassword: function changeFieldPassword() {}
}, _temp)) || _class);
exports.default = PassRecoveryStepTwo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PassRecovery/PassRecoveryStepTwo/PassRecoveryStepTwo.jsx
// module id = 1726
// module chunks = 0